/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Note/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditNoteDialog from './EditNoteDialog/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import ViewNoteDialog from './ViewNoteDialog/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Note({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Note",
  triggerRef,
  onMouseEnterTrigger,
  onMouseMoveTrigger,
  onMouseLeave,
  hovered,
  top,
  left,
  contentRef,
  onMouseEnterContent,
  onEdit,
  onClose
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventContentValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'content',
})
  return (<React.Fragment
>
<div
  data-testid="Note.Vertical"
  data-view-path={viewPath}
 ref={triggerRef}
 onMouseEnter={onMouseEnterTrigger}
 onMouseMove={onMouseMoveTrigger}
 onMouseLeave={onMouseLeave}
 style={{'--bblr-2-aI8I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-aI8I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-aI8I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-aI8I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-6-aI8I': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-7-aI8I': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-8-aI8I': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-9-aI8I': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-aI8I': hovered ? "#f9e19a" : "#F8E3A3"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event.content"
 text={eventContentValueData}
 weight="regular"
 size="small"
 wordBreak="break-word"
/>
</div>
<ViewNoteDialog
  viewPath={`${viewPath}/ViewNoteDialog`}
 top={top}
 left={left}
 isOpen={hovered}
 contentRef={contentRef}
 onMouseEnter={onMouseEnterContent}
 onMouseLeave={onMouseLeave}
 onEdit={onEdit}
/>
<EditNoteDialog
  viewPath={`${viewPath}/EditNoteDialog`}
 top={top}
 left={left}
 contentRef={contentRef}
 onClose={onClose}
/>
{children}
</React.Fragment>)
}